export const OPTION_ONE_TITLE_RAW_CV = "Option 1: Upload a CV file";
export const OPTION_TWO_TITLE_RAW_CV = "Option 2: Create new CV";
export const STEP_ONE_TITLE_RAW_CV = 'Step One: Upload a CV file';
export const STEP_TWO_TITLE_RAW_CV = 'Step Two: Edit CV and add missing information';
